
//code review--Completed
//documentation-- completed


//imports

import MainLayout from '../components/MainLayout'
import { mainTable } from '../css/Common'
import AddScreenTitle from '../components/AddScreenTitle'
import InputText from '../ReusableComponents/InputText'
import TextArea from '../ReusableComponents/TextArea'
import Buttons from '../components/Buttons'
import MainPopup from '../popup-containers/MainPopup'
import PopUpButtons from '../components/PopUpButtons'
import react, { useState, useEffect } from 'react';
import PopUpScreenTitle from '../components/PopUpScreenTitle'
import CancellationReasonPopup from '../popup-containers/CancellationReasonPopup'
import GridPage from '../components/GridPage'
import { reasonForCancelHeader } from '../components/HeaderAttribute'
import { BindAPI, IUDAPI } from '../services/APIConnection'
import toast from 'react-hot-toast'
import Loader from '../ReusableComponents/Loader'
import ErrorPopup from '../ReusableComponents/ErrorPopup'

export default function CancellationReason() {

  // useState

  const [popUpData, setPopUpData] = useState(null);
  const [visibleAdd, setVisibleAdd] = useState(false);
  const [visibleTable, setVisibleTable] = useState(true);
  const [addScreenTitle, setAddScreenTitle] = useState(false);
  const [updateScreenTitle, setUpdateScreenTitle] = useState(false);
  const [viewDetails, setViewDetails] = useState(false);
  const [deleteDetails, setDeleteDetails] = useState(false);
  const [blockDetails, setBlockDetails] = useState(false);
  const [unBlockDetails, setUnBlockDetails] = useState(false);
  const [rowIndex, setRowIndex] = useState(false);
  const [popUpOpen, setpopUpOpen] = useState(false);
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [MstCancellationReasonId, setMstCancellationReasonId] = useState("");

  const [bindreasonforcanceldata, setbindreasonforcanceldata] = useState([]);
  const [errors, setErrors] = useState({});
  const [formFields, setFormFields] = useState({
    reason: "",
    description: "",
  });

  // user session storage
  var createdBy = sessionStorage.getItem("createdBy");

  // to update the values on field 
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormFields((prev) => ({ ...prev, [name]: value }));

    if (value.trim() !== "") {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    }
  };

  // To show the values entered by user in table-come from database
  useEffect(() => {
    BindCancellationReasonData();
  }, []);

  const BindCancellationReasonData = async () => {

    const response = await BindAPI("CancellationReason/BindCancellationReason")
    console.log("API Response:", response);
    if (response && response.data) {
      setbindreasonforcanceldata(response.data.Table)
    } else {
      setbindreasonforcanceldata([]);
    }
  };



  // To show the Errors, if user accidentally leaves the fields

  const handleBlur = (e) => {
    const { name, value } = e.target;
    const formattedName = name.charAt(0).toUpperCase() + name.slice(1);
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: value.trim() === "" ? `Enter the ${formattedName}.` : "",
    }));
  };

  // To validate the inputs while clicks on submit
  const validateForm = () => {
    
    const newErrors = {};
    if (!formFields.reason) newErrors.reason = "Enter the Reason";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  // handle submit to store the data in the db
  const handleSubmit = async (rowIndex, flag) => {
    


    setSubmitBtnDisabled(true);
    setIsLoading(true);

    // to validate form when insert and update
    const isValid = validateForm();
    if (flag == 1 || flag == 2) {
      if (!isValid) {                 // if entered details are invalid
        setIsOpen(true);
        setIsLoading(false);
        setSubmitBtnDisabled(false);
      }
      if (isValid) {                     // if entered details are valid
        setIsOpen(false);
        setIsLoading(true);


        const data = {                     // data to be send to api, if add/update

          mstCancellationReasonId: MstCancellationReasonId ? MstCancellationReasonId : 0,
          reason: formFields.reason,
          description: formFields.description,
          createdBy: createdBy,
          flag: flag,
        };
        const response = await IUDAPI([data], "CancellationReason/IUDCancellationReason");
        if (flag == 1) {                                              //if flag ==1 , add
          if (response.data.Table[0].Result === 'S') {
            toast.success("Cancellation Reason Data Inserted Seccessfully", {
              duration: 3000,
              position: "top-center",
            });
            setTimeout(cancel, 3000);
          } else {
            toast.error("cancellation Reason data insert Failed", {
              duration: 3000,
              position: "top-center",
            });
            setTimeout(cancel, 3000);
          }
        } else if (flag == 2) {                     //if flag ==2 , update

          if (response.data.Table[0].Result === "M") {
            toast.success("Cancellation Reason data modified successfully! 👍", {
              duration: 3000,
              position: "top-center",
            });
            setTimeout(cancel, 3000);
          } else {
            toast.error("Cacnellation Reason data modification failed 👎", {
              duration: 3000,
              position: "top-center",
            });
            setTimeout(cancel, 3000);
          }
        }
      } else { setSubmitBtnDisabled(false); }
    } else {                                               // if flag is neither 1 or 2

      const data = {                                        //data to be send to api for 3-delete,4-active,5-inactive
        mstCancellationReasonId: MstCancellationReasonId ? MstCancellationReasonId : 0,
        createdBy: createdBy,
        flag: flag,
      };

      const response = await IUDAPI([data], "CancellationReason/IUDCancellationReason");

      if (flag == 3) {                                            //if flag ==3 , delete
        if (response.data.Table[0].Result === 'D') {
          toast.success("Cancellation Reason Data Deleted Successfully", {
            duration: 3000,
            position: "top-center",
          });
          setTimeout(cancel, 3000);
        } else {
          toast.error("Failed to delete Cancellation Reason", {
            duration: 3000,
            position: "top-center",
          });
        }
        setTimeout(cancel, 3000);
      } else if (flag == 4) {                                               //if flag ==4 , Active
        if (response.data.Table[0].Result === "B") {
          toast.success("Cancellation Reason Data Inactivated successfully", {
            duration: 3000,
            position: "top-center",
          });
          setTimeout(cancel, 3000);
        } else {
          toast.error("Cancellation Reason Data Inactivated Failed", {
            duration: 3000,
            position: "top-center",
          });
          setTimeout(cancel, 3000);
        }

      } else if (flag == 5) {                                                 //if flag ==4 ,inactive
        if (response.data.Table[0].Result === "UB") {
          toast.success("Cancellation Reason Data Activated Successfully", {
            duration: 3000,
            position: "top-center",
          });
          setTimeout(cancel, 3000);
        } else {
          toast.error("Cancellation Data Reason Activated Failed", {
            duration: 3000,
            position: "top-center",
          });
          setTimeout(cancel, 3000);
        }
      }
    }

    console.log("Submit reason for lost:", formFields);
    cancel();
  };


  //Cancel button
  const cancel = () => {
    setVisibleAdd(false);
    setIsLoading(false)
    setVisibleTable(true);
    setAddScreenTitle(false);
    setUpdateScreenTitle(false);
    setFormFields({ reason: "", description: "" });
    setErrors({});
    setpopUpOpen(false);
    setRowIndex(null);
    setViewDetails(false);
    setDeleteDetails(false);
    setBlockDetails(false);
    setUnBlockDetails(false);
    BindCancellationReasonData();
    setSubmitBtnDisabled(false);
  };

  //Edit functionality
  const handleEdit = (rowIndex) => {
    setRowIndex(rowIndex);
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(false);
    setUpdateScreenTitle(true);
    setMstCancellationReasonId(bindreasonforcanceldata[rowIndex].MstCancellationReasonId)
    setFormFields({
      ...formFields,
      reason: bindreasonforcanceldata[rowIndex].Reason,
      description: bindreasonforcanceldata[rowIndex].Description,
    });
  };


  //to handle Pop Up
  const handlereason = (rowIndex, flag) => {
    setRowIndex(rowIndex);
    setpopUpOpen(true);

    if (flag === 1) {
      setViewDetails(true);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(false);
    } else if (flag === 3) {
      setViewDetails(false);
      setDeleteDetails(true);
      setBlockDetails(false);
      setUnBlockDetails(false);
      setRowIndex(rowIndex);
    } else if (flag === 4) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(true);

      setUnBlockDetails(false);
    } else if (flag === 5) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(false);

      setUnBlockDetails(true);
    }

    const rowData = bindreasonforcanceldata[rowIndex];
    setMstCancellationReasonId(bindreasonforcanceldata[rowIndex].MstCancellationReasonId);
    setPopUpData(rowData);


  };

  // Add button Functionality
  const showAdd = () => {
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(true);
    setUpdateScreenTitle(false);
    BindCancellationReasonData();
  };



  return (
    <>
      <MainLayout pageName={"2"}>
        <Loader    //loader
          isVisible={isLoading}
          size="h-20 w-20"
          color="border-t-black"
          blur={true}
        />
        {visibleTable && (
          <GridPage   //gridpage
            header={reasonForCancelHeader}
            title={"Cancellation Reason"}
            records={bindreasonforcanceldata}
            handleEdit={handleEdit}
            handleAction={handlereason}
            showAdd={showAdd}
            blockview={true}
          />
        )}

        {visibleAdd && (
          <div className="w-full">
            <div className="flex flex-col w-full">
              <div className={mainTable.clientMasterMainAdd}>
                <AddScreenTitle   //addscreentitle
                  addScreenTitle={addScreenTitle}
                  updateScreenTitle={updateScreenTitle}
                  title="Cancellation Reason"
                />
              </div>
            </div>

            <div className="mx-auto mt-16 md:w-2/5 w-full flex items-center justify-center border-black">
              <div className="relative w-full h-full max-w-xl md:h-auto">
                <div className="relative bg-white rounded-lg shadow">
                  <div className="px-6 py-6 lg:px-8">
                    <form>
                      <InputText             //input field
                        inputType="text"
                        title="Reason"
                        name="reason"
                        classStar="text-red-500"
                        controlFunc={handleInputChange}
                        controlFuncBlur={handleBlur}
                        content={formFields.reason}
                        disabled={false}
                        errorMessage={errors.reason}
                        isRequired={true}
                      />

                      <TextArea              //text area
                        title="Description"
                        rows={5}
                        name="description"
                        content={formFields.description}
                        resize={false}
                        placeholder="Enter description"
                        controlFunc={(e) =>
                          setFormFields((prev) => ({
                            ...prev,
                            description: e.target.value,
                          }))
                        }
                        controlFuncBlur={() => { }}
                        disabled={false}
                        // tabIndex="0"
                        errorMessage=""
                      />

                      <div className="flex justify-center mt-6">
                        <Buttons             //Buttons
                          addScreenTitle={addScreenTitle}
                          updateScreenTitle={updateScreenTitle}
                          disabledBtn={submitBtnDisabled || isLoading}
                          viewSaveButton={false}
                          handleSubmit={handleSubmit}
                          cancel={cancel}
                        />
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {isOpen && <ErrorPopup closeModal={() => setIsOpen(false)} />}
        <MainPopup   //Main Pop up
          popUpOpen={popUpOpen}
          setpopUpOpen={setpopUpOpen}
          Open={() => setpopUpOpen(false)}
        >
          <div>
            <PopUpScreenTitle  //Popup screen Title
              title="Cancellation Reason"
              setpopUpOpen={setpopUpOpen}
              viewDetails={viewDetails}
              deleteDetails={deleteDetails}
              blockDetails={blockDetails}
              unBlockDetails={unBlockDetails}
            />
            <CancellationReasonPopup data={popUpData} />         
          </div>

          <PopUpButtons        //popup buttons
            deleteDetails={deleteDetails}
            blockDetails={blockDetails}
            unBlockDetails={unBlockDetails}
            rowIndex={rowIndex}
            handleSubmit={handleSubmit}
            cancel={cancel}
            disabledBtn={submitBtnDisabled}
          />
        </MainPopup>
      </MainLayout>
    </>
  )
}
